// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Button,
  Input,
  Label,
} from 'reactstrap';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';

// Services
import Services from '../../../services';

// Types
type $Props = $Translate & {
  label: string;
  onFound: (arg0: $Model<'RegattaPaymentDiscount'>) => Promise<void>;
  regattaPaymentDiscount: $Model<'RegattaPaymentDiscount'> | null;
};

type $State = {
  invalid: boolean;
  loading: boolean;
  search: string;
};

class InputDiscountView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      invalid: false,
      loading: false,
      search: '',
    };
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async check(): Promise<void> {
    const {
      onFound,
    } = this.props;
    const {
      search,
    } = this.state;

    try {
      await this.setStateAsync({
        invalid: false,
        loading: true,
      });

      const regattaPaymentDiscount = await Services.Api.getLastRegattaPaymentDiscount({
        search,
      });

      if (regattaPaymentDiscount !== null) {
        await onFound(regattaPaymentDiscount);
      } else {
        await this.setStateAsync({
          invalid: true,
        });
      }

      await this.setStateAsync({
        loading: false,
      });
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);

      await this.setStateAsync({
        loading: false,
      });
    }
  }

  renderInput() {
    const {
      regattaPaymentDiscount,
      t,
    } = this.props;
    const {
      loading,
      search,
    } = this.state;

    if (regattaPaymentDiscount !== null) {
      return (
        <div className={'input-group'}>
          <Input
            className={'bg-white'}
            disabled
            name={'search'}
            value={regattaPaymentDiscount.Name}
          />
          <div className={'input-group-append'}>
            <span className={'input-group-text bg-white'}>
              <em className={'text-success icon-check'} />
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className={'input-group'}>
        <Input
          name={'search'}
          onChange={(e) => this.setState({
            search: e.target.value,
          })}
          value={search}
        />
        {search !== '' && (
          <Button
            className={'input-group-append d-flex align-items-center'}
            color={'success'}
            disabled={loading === true}
            onClick={() => this.check()}
          >
            {loading ? (
              <span
                aria-hidden={'true'}
                className={'spinner-border spinner-border-sm'}
                role={'status'}
              />
            ) : t('Apply')}
          </Button>
        )}
      </div>
    );
  }

  render() {
    const {
      label,
      t,
    } = this.props;
    const {
      invalid,
    } = this.state;

    return (
      <>
        <Label>
          {label}
        </Label>
        {this.renderInput()}
        <span className={'text-danger'}>
          {invalid === true ? t('Discount code invalid') : '\u00A0'}
        </span>
      </>
    );
  }
}

export default InputDiscountView;
